import type { ReactNode } from 'react'

interface LayoutProps {
  children?: ReactNode;
  showNavigation?: boolean;
  showFooter?: boolean;
  isMobile?: boolean;
}

/**
 * Main Layout Component
 * Wraps pages with consistent navigation, footer, and styling
 * Responsive design for mobile and desktop
 */
export function Layout({
  children,
  showNavigation: _showNavigation = true,
  showFooter: _showFooter = true,
  isMobile: _isMobile = false,
}: Readonly<LayoutProps>) {
  return (
    <div className="min-h-screen bg-[#0A0A0B] text-[#e5e1e4] font-[Hanken_Grotesk] flex flex-col">
      <main className="flex-1">{children}</main>
    </div>
  );
}

export default Layout;
